var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aCategoryIcon{fill:none;}.bCategoryIcon{fill:#b30200;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aCategoryIcon",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bCategoryIcon",
    d: "M4,3A1,1,0,1,0,5,4,1,1,0,0,0,4,3ZM7,3V5H21V3ZM4,7A1,1,0,1,0,5,8,1,1,0,0,0,4,7ZM7,7V9H19V7ZM4,11a1,1,0,1,0,1,1A1,1,0,0,0,4,11Zm3,0v2H17V11ZM4,15a1,1,0,1,0,1,1A1,1,0,0,0,4,15Zm3,0v2h8V15ZM4,19a1,1,0,1,0,1,1A1,1,0,0,0,4,19Zm3,0v2h6V19Z",
    transform: "translate(4 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.eb338d2fea0be0dd5185073201b2f813.svg";
export { ForwardRef as ReactComponent };